import * as React from "react";
interface props {
  className?: string;
}
const ProfileIconSvg2 = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="125"
    height="125"
    className={className}
    fill="none"
    viewBox="0 0 125 125"
  >
    <rect width="125" height="125" fill="#FEECE6" rx="62.5"></rect>
    <path
      fill="#FF752C"
      d="M89.555 84.585c-4.004-6.923-10.175-11.887-17.377-14.24a18.93 18.93 0 1 0-19.366 0c-7.202 2.35-13.372 7.314-17.377 14.24a2.103 2.103 0 1 0 3.642 2.103c4.953-8.56 13.709-13.672 23.418-13.672 9.71 0 18.465 5.111 23.419 13.672a2.102 2.102 0 1 0 3.64-2.103m-41.783-30.5A14.724 14.724 0 1 1 62.495 68.81a14.74 14.74 0 0 1-14.723-14.723"
    ></path>
  </svg>
);

export default ProfileIconSvg2;
